export const isCODWithoutPartialPayment = (deliveryOption) =>
  deliveryOption.key === "cod" && deliveryOption.partialPaymentPercentage === undefined;
